module.exports = __webpack_public_path__ + "static/media/medal.9f48aba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/milestone/medal.png
// module id = 2095
// module chunks = 0